export const TRUTHY_VALUES = [true, 1, '1', 'True', 'true'];
